import { AppModule } from './app.module';
import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';

import { ProductComponent } from './products/product.component';
import { ComparePageComponent } from './products/compare/compare-page/compare-page.component';
import { RedirectComponent } from './redirect/redirect.component';

export const routes: Routes = [
  { path: ':locale/search', component: ProductComponent },
  { path: ':locale/studio/store', component: ProductComponent },
  { path: ':locale/studio/store/compare', component: ComparePageComponent },
  { path: ':locale/studio/store/:category', component: ProductComponent },
  { path: '**', component: RedirectComponent }
];

export const appRoutingProviders: any[] = [];

export const routing: ModuleWithProviders<AppModule> = RouterModule.forRoot(routes, {});
